import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UsuarioService } from 'src/app/services/http/usuario.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-confirmar-email',
  templateUrl: './confirmar-email.component.html',
  styleUrls: ['./confirmar-email.component.scss']
})
export class ConfirmarEmailComponent implements OnInit {

  status: 'sucesso' | 'erro' | 'carregando' = 'carregando';
  mensagem: string = '';

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private usuarioService: UsuarioService,
  ) { }

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');

    if (!token) {
      this.status = 'erro';
      this.mensagem = 'Token não informado.';
      return;
    }

    this.usuarioService.confirmarEmail(token)
      .then(() => {
        this.status = 'sucesso';
        this.mensagem = 'E-mail confirmado com sucesso! Você já pode acessar o sistema.';
      })
      .catch(( err) => {
        console.log(err)
        this.status = 'erro';
        this.mensagem = 'Erro ao confirmar o e-mail. Verifique o link ou entre em contato com o suporte.';
      });
  }

}
